import { render, staticRenderFns } from "./EditProductSubcategoryComponent.vue?vue&type=template&id=bf39cc9c&scoped=true"
import script from "./EditProductSubcategoryComponent.vue?vue&type=script&lang=js"
export * from "./EditProductSubcategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf39cc9c",
  null
  
)

export default component.exports